export default function isValidNumber(value) {
    const numberRegex = /^\s*[+-]?(\d+|\d*\.\d+|\d+\.\d*)([Ee][+-]?\d+)?\s*$/;
    return numberRegex.test(value);
}
//# sourceMappingURL=isValidNumber.js.map